import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 2,
	kind: "context",
	label: "Contexto 5 (plantilla)",
	nextRoute: ROUTES.SCENARIO2_FIN,
});
